<div class="modal fade" :id="modalComponentId" tabindex="-1" role="dialog" :aria-labelledby="modalComponentId + 'Label'" aria-hidden="true">
    <div class="modal-dialog modal-xl" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" :id="modalComponentId + 'Label'">{{modalHeading}}</h5>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="onModalCloseClick">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body">
                <data-table
                        :headings="productsHeadings" 
                        :data="products" 
                        :hasActions="false" 
                        @filterSearchClicked="onFilterSearchClicked">
                    <template #filter>
                        <div class="p-3">
                            <div class="input-group pb-4">
                                <input type="text" class="form-control" placeholder="Search" aria-label="Search" aria-describedby="basic-addon1" v-model="customerSearchQuery">
                                <div class="input-group-append">
                                    <span class="input-group-text" id="basic-addon1">
                                        <i class="fas fa-search"></i>
                                    </span>
                                </div>
                            </div>
                        </div>
                    </template>
                </data-table>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-primary" @click="onModalCloseClick">OK</button>
            </div>
        </div>
    </div>
</div>